import { render, staticRenderFns } from "./SysDataSourceModal.vue?vue&type=template&id=4c96a09b&scoped=true"
import script from "./SysDataSourceModal.vue?vue&type=script&lang=js"
export * from "./SysDataSourceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c96a09b",
  null
  
)

export default component.exports